import { useTransaction } from "hooks/useTransactions";
import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import React, { useEffect, useState } from "react";
import { bool } from "prop-types";
import { Col, Row } from "react-bootstrap";
import Notification from "pages/_components/Notification";
import { useLocation } from "react-router-dom";
import { actions as cedipActions } from "reducers/cedip";
import TransmitCedipSummaryBody from "./Summary";
import TransmitCedipShortSummaryBody from "./SummaryShortDetail";
import { ceditTransactionWithoutTicket } from "../../../../../util/cedip";

const TransmitCedipSummaryPage = (props) => {
    const { state = {} } = useLocation();
    const { isFlowComplete = false } = state;
    const { isDesktop } = props;

    const formatTransactionCedip = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/cedip/transmit/confirmation",
        cedipActions.setTransmitCedip,
        cedipActions.cleanCedipTicket,
        formatTransactionCedip,
    );
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "ticket.cedip.transmit.title",
        id,
        "transmitCedip.transaction.page",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const { isFinished, isBackoffice } = status;
    const { idActivity, activityName } = transaction;

    useEffect(() => {
        if (idActivity === "transmit.cedip.send") {
            dispatch(cedipActions.setCedipAction("CEDIP-TRANSMIT"));
        }
    }, [idActivity, dispatch]);

    const backLink = () => {
        let link;
        if (isDesktop) {
            if (isFlowComplete) {
                link = "/depositsCedip";
            } else {
                link = "";
            }
        } else {
            link = "/depositsCedip";
        }
        return link;
    };
    const backLinkTo = backLink();

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    const transactionFullDetailSummary = () => (
        <TransactionCard transaction={transaction}>
            <TransactionHeader title="ticket.cedip.transmit.title" showLogo={false} {...props} />
            <div className="ticket">
                <div className="ticket__wrapper">
                    <div className="ticket__header" />
                    <TransmitCedipSummaryBody
                        ticket
                        {...props}
                        isFinished={isFinished}
                        setShowMoreData={setShowMoreData}
                        showMoreData={showMoreData}
                        isDesktop={isDesktop}
                    />
                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                </div>
            </div>
        </TransactionCard>
    );

    const transactionShortDetailSummary = () => (
        <TransactionCard transaction={transaction}>
            <TransactionHeader title={activityName} {...props} titleWithI18N={false} {...props} />
            <div className="ticket">
                <div className="ticket__wrapper">
                    <div className="ticket__header" />
                    <TransmitCedipShortSummaryBody {...props} isDesktop={isDesktop} />
                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                </div>
            </div>
        </TransactionCard>
    );

    return (
        <>
            {isFinished && <Notification scopeToShow="transmitCedip.transaction.page" />}
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id="ticket.cedip.transmit.title"
                    metaTitle="cedip.transmit"
                    backLinkTo={backLinkTo}
                />
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        {!ceditTransactionWithoutTicket.includes(idActivity) && transactionFullDetailSummary()}
                        {ceditTransactionWithoutTicket.includes(idActivity) && transactionShortDetailSummary()}
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {!isFinished && (
                                <>
                                    <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                        <Button
                                            onClick={() => dispatch(push("/desktop"))}
                                            label="forms.transaction.ticket.actions.backToHome"
                                            className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                        />
                                    </Col>
                                    {showSignButton && (
                                        <Col xs={12} md={4} mdOffset={6}>
                                            <Button
                                                onClick={handleSignTransaction}
                                                label="forms.signTransaction.link"
                                                className="btn btn-primary"
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                            {isFinished && (
                                <>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <Button
                                            onClick={() => dispatch(push("/desktop"))}
                                            label="forms.transaction.ticket.actions.backToHome"
                                            className=" btn-outline"
                                        />
                                    </Col>
                                    <Col xs={12} md={4} mdOffset={6}>
                                        <Button
                                            onClick={handleDownload}
                                            image="images/figma/icon/download.svg"
                                            label="global.download"
                                            className="btn-primary"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

TransmitCedipSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransmitCedipSummaryPage;
